export const LABEL_OPTIONS = {
  EMAIL: 'EMAIL',
  DOWNLOAD: 'DOWNLOAD',
} as const;

export type LabelOption = keyof typeof LABEL_OPTIONS;
